export default "__VITE_ASSET__ea033f84__"